module.exports = __webpack_public_path__ + "img/wxOfficeCode.89a52f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wxOfficeCode.jpg
// module id = XBZK
// module chunks = 0